import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import AuthService from "../../services/auth.service";

export const getCurrency= createAsyncThunk('getCurrency', async () => {
    const response = await AuthService.currency();
    return response?.data;   
});


export const currencySlice = createSlice({
    name: 'currency',
    initialState: {
        //isLoading: false,
        currency:[],
        //isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        // builder.addCase(getCurrency.pending, (state, action) => {
        //     state.isLoading = true;
        // });
        builder.addCase(getCurrency.fulfilled, (state, action) => {
            //state.isLoading = false;
            state.currency = action.payload;
        });
        // builder.addCase(getCurrency.rejected, (state, action) => {
        //     console.log('Error', action.payload);
        //     state.isError = true;
        // });
    }
})

export default currencySlice.reducer